import DatatableComponent from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import ActionButton from "../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"
import BlueTableHeading from "../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import GrayDivider from "../../../common/AdminCommonComponents/GrayDivider/GrayDivider"

const Inventory = () => {

  const options = [
    { label: "Product Detail" },
    { label: "Delete", action: () => console.log('product delete') },
  ]

  const tableData = [
    { sr: '1', productId: 'P-1001', productName: 'Bluetooth Headphones', sku: 'BTH-001', warehouse: 'ABC Logistics', stockLevel: '15 units', lastUpdated: '01-12-2024' },
    { sr: '2', productId: 'P-1001', productName: 'wireless keyboard', sku: 'WRK-102', warehouse: 'ABC Logistics', stockLevel: '250 units', lastUpdated: '01-12-2024' },
    { sr: '3', productId: 'P-1001', productName: 'Bluetooth Headphones', sku: 'BTH-001', warehouse: 'ABC Logistics', stockLevel: '15 units', lastUpdated: '01-12-2024' },
    { sr: '4', productId: 'P-1001', productName: 'wireless keyboard', sku: 'WRK-102', warehouse: 'ABC Logistics', stockLevel: '250 units', lastUpdated: '01-12-2024' },
    { sr: '5', productId: 'P-1001', productName: 'Bluetooth Headphones', sku: 'BTH-001', warehouse: 'ABC Logistics', stockLevel: '15 units', lastUpdated: '01-12-2024' },
    { sr: '6', productId: 'P-1001', productName: 'wireless keyboard', sku: 'WRK-102', warehouse: 'ABC Logistics', stockLevel: '250 units', lastUpdated: '01-12-2024' },
    { sr: '7', productId: 'P-1001', productName: 'Bluetooth Headphones', sku: 'BTH-001', warehouse: 'ABC Logistics', stockLevel: '15 units', lastUpdated: '01-12-2024' },
    { sr: '8', productId: 'P-1001', productName: 'wireless keyboard', sku: 'WRK-102', warehouse: 'ABC Logistics', stockLevel: '250 units', lastUpdated: '01-12-2024' },
    { sr: '9', productId: 'P-1001', productName: 'Bluetooth Headphones', sku: 'BTH-001', warehouse: 'ABC Logistics', stockLevel: '15 units', lastUpdated: '01-12-2024' },
    { sr: '10', productId: 'P-1001', productName: 'wireless keyboard', sku: 'WRK-102', warehouse: 'ABC Logistics', stockLevel: '250 units', lastUpdated: '01-12-2024' },
  ]

  const columns = [
    { name: 'Sr.', selector: (row) => row.sr },
    { name: 'Product ID', selector: (row) => row.productId },
    { name: 'SKU', selector: (row) => row.sku },
    { name: 'Warehouse', selector: (row) => row.warehouse },
    { name: 'Stock Level', selector: (row) => row.stockLevel },
    { name: 'Last Update', selector: (row) => row.lastUpdated },
    {
      name: "Action",
      cell: () => <ActionButton options={options} />
    }
  ]

  const statsData = [
    { title: "total Products".toUpperCase(), value: 0 },
    { title: "Active Products".toUpperCase(), value: 0 },
    { title: "Out of stock Products".toUpperCase(), value: 0 },
  ]

  return (
    <div>
      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow mt-3">
        <BlueTableHeading className='px-4 py-3 fw-semibold fs-5'>Inventory Monitoring</BlueTableHeading>
        <GrayDivider />
        <div className="p-3">
          <DatatableComponent data={tableData} columns={columns} type='gray' striped pagination />
        </div>
      </div>
    </div>
  )
}

export default Inventory